import React from 'react';

import Resources from './Resources';

export default function Index() {
  return (
    <div className="content">
      <Resources />
    </div>
  );
}
